<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">
        <h5 class="mb-0">Dashboard Recensement</h5>
      </div>
      <div class="d-flex align-items-center">
        <button type="button" @click="refreshData()" v-if="!isLoading"
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-primary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none">
          <i class="flaticon-refresh position-relative ms-5 fs-12"></i>
          Actualiser
        </button>
        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-primary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          type="button" v-if="isLoading" disabled>
          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
          <span class="visually-hidden">Chargement...</span>
        </button>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <!-- Stats Cards -->
      <div class="row mb-25">
        <div class="col-md-3 col-sm-6 mb-15">
          <div class="card border-0 rounded-0 bg-primary text-white">
            <div class="card-body p-20">
              <div class="d-flex align-items-center">
                <div class="flex-shrink-0">
                  <i class="flaticon-users fs-30 text-white"></i>
                </div>
                <div class="flex-grow-1 ms-15">
                  <h6 class="mb-5 text-white">Total Recensements</h6>
                  <h4 class="mb-0 text-white">{{ stats.totalRecensements || 0 }}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 mb-15">
          <div class="card border-0 rounded-0 bg-success text-white">
            <div class="card-body p-20">
              <div class="d-flex align-items-center">
                <div class="flex-shrink-0">
                  <i class="flaticon-check fs-30 text-white"></i>
                </div>
                <div class="flex-grow-1 ms-15">
                  <h6 class="mb-5 text-white">Recensements Existant</h6>
                  <h4 class="mb-0 text-white">{{ stats.recensementsExistant || 0 }}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 mb-15">
          <div class="card border-0 rounded-0 bg-warning text-white">
            <div class="card-body p-20">
              <div class="d-flex align-items-center">
                <div class="flex-shrink-0">
                  <i class="flaticon-plus fs-30 text-white"></i>
                </div>
                <div class="flex-grow-1 ms-15">
                  <h6 class="mb-5 text-white">Recensements Nouveau</h6>
                  <h4 class="mb-0 text-white">{{ stats.recensementsNonExistant || 0 }}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 mb-15">
          <div class="card border-0 rounded-0 bg-info text-white">
            <div class="card-body p-20">
              <div class="d-flex align-items-center">
                <div class="flex-shrink-0">
                  <i class="flaticon-search fs-30 text-white"></i>
                </div>
                <div class="flex-grow-1 ms-15">
                  <h6 class="mb-5 text-white">Total Vérifications</h6>
                  <h4 class="mb-0 text-white">{{ stats.totalVerifications || 0 }}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Charts Row -->
      <div class="row mb-25">
        <div class="col-md-6 mb-15">
          <div class="card border-0 rounded-0 bg-white">
            <div class="card-header bg-transparent border-0 p-20">
              <h6 class="mb-0">Recensements par Agent</h6>
            </div>
            <div class="card-body p-20">
              <canvas ref="agentChart" height="300"></canvas>
            </div>
          </div>
        </div>
        <div class="col-md-6 mb-15">
          <div class="card border-0 rounded-0 bg-white">
            <div class="card-header bg-transparent border-0 p-20">
              <h6 class="mb-0">Évolution des 7 derniers jours</h6>
            </div>
            <div class="card-body p-20">
              <canvas ref="dailyChart" height="300"></canvas>
            </div>
          </div>
        </div>
      </div>

      <!-- Tables Row -->
      <div class="row">
        <div class="col-md-6 mb-15">
          <div class="card border-0 rounded-0 bg-white">
            <div class="card-header bg-transparent border-0 p-20">
              <h6 class="mb-0">Recensements par Agent</h6>
            </div>
            <div class="card-body p-20">
              <div class="table-responsive">
                <table class="table text-nowrap align-middle mb-0">
                  <thead>
                    <tr>
                      <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                        Agent
                      </th>
                      <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                        Nombre
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(agent, index) in stats.recensementsParAgent" :key="index">
                      <td class="shadow-none lh-1 fw-medium text-primary">
                        {{ agent.agentNom }} {{ agent.agentPrenom }}
                      </td>
                      <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                        {{ agent.nombreRecensements }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 mb-15">
          <div class="card border-0 rounded-0 bg-white">
            <div class="card-header bg-transparent border-0 p-20">
              <h6 class="mb-0">Derniers Recensements</h6>
            </div>
            <div class="card-body p-20">
              <div class="table-responsive">
                <table class="table text-nowrap align-middle mb-0">
                  <thead>
                    <tr>
                      <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                        Nom
                      </th>
                      <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                        État
                      </th>
                      <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                        Date
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(recensement, index) in stats.derniersRecensements" :key="index">
                      <td class="shadow-none lh-1 fw-medium text-primary">
                        {{ recensement.nom }} {{ recensement.prenom }}
                      </td>
                      <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                        <span class="badge" :class="getEtatBadgeClass(recensement.etatUsager)">
                          {{ recensement.etatUsager }}
                        </span>
                      </td>
                      <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                        {{ format_date(recensement.createdAt) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref, defineComponent, onMounted, nextTick } from "vue";
import {
  format_date,
  error,
  success,
  checkPermission,
} from "@/utils/utils";
import axios from "axios";
import Chart from 'chart.js/auto';

export default defineComponent({
  name: "RecensementDashboard",
  setup: () => {
    const isLoading = ref(false);
    const stats = ref({
      totalRecensements: 0,
      recensementsExistant: 0,
      recensementsNonExistant: 0,
      totalVerifications: 0,
      recensementsParAgent: [] as Array<{agentNom: string, agentPrenom: string, nombreRecensements: number}>,
      dailyStats: [] as Array<{date: string, existant: number, nonExistant: number}>,
      derniersRecensements: [] as Array<{nom: string, prenom: string, etatUsager: string, createdAt: string}>
    });
    const agentChart = ref<HTMLCanvasElement | null>(null);
    const dailyChart = ref<HTMLCanvasElement | null>(null);

    const loadStats = async () => {
      try {
        isLoading.value = true;
        const response = await axios.get("/recensement-usager/advanced-stats");
        if (response.data.success) {
          stats.value = response.data.data;
          await nextTick();
          updateCharts();
        }
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          error(err.response.data.message || err.message);
        } else {
          error("Erreur lors du chargement des statistiques");
        }
      } finally {
        isLoading.value = false;
      }
    };

    const updateCharts = () => {
      updateAgentChart();
      updateDailyChart();
    };

    const updateAgentChart = () => {
      if (!agentChart.value || !stats.value.recensementsParAgent.length) return;
      
      const ctx = agentChart.value.getContext('2d');
      if (!ctx) return;

      new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: stats.value.recensementsParAgent.map(agent => `${agent.agentNom} ${agent.agentPrenom}`),
          datasets: [{
            data: stats.value.recensementsParAgent.map(agent => agent.nombreRecensements),
            backgroundColor: [
              '#FF6384',
              '#36A2EB',
              '#FFCE56',
              '#4BC0C0',
              '#9966FF',
              '#FF9F40'
            ]
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'bottom'
            }
          }
        }
      });
    };

    const updateDailyChart = () => {
      if (!dailyChart.value || !stats.value.dailyStats.length) return;
      
      const ctx = dailyChart.value.getContext('2d');
      if (!ctx) return;

      new Chart(ctx, {
        type: 'line',
        data: {
          labels: stats.value.dailyStats.map(day => day.date),
          datasets: [
            {
              label: 'Existant',
              data: stats.value.dailyStats.map(day => day.existant),
              borderColor: '#28a745',
              backgroundColor: 'rgba(40, 167, 69, 0.1)',
              tension: 0.4
            },
            {
              label: 'Nouveau',
              data: stats.value.dailyStats.map(day => day.nonExistant),
              borderColor: '#ffc107',
              backgroundColor: 'rgba(255, 193, 7, 0.1)',
              tension: 0.4
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              beginAtZero: true
            }
          }
        }
      });
    };

    const refreshData = async () => {
      await loadStats();
    };

    const getEtatBadgeClass = (etat: string) => {
      switch (etat) {
        case 'Existant':
          return 'badge-success';
        case 'Non Existant':
          return 'badge-warning';
        default:
          return 'badge-secondary';
      }
    };

    onMounted(async () => {
      await loadStats();
    });

    return {
      isLoading,
      stats,
      agentChart,
      dailyChart,
      refreshData,
      format_date,
      getEtatBadgeClass,
      checkPermission,
    };
  },
});
</script>
